module.exports = __webpack_public_path__ + "img/icon4.a19ffd2f.jpg";